import { render, staticRenderFns } from "./Hengelen.vue?vue&type=template&id=32490667&"
import script from "./Hengelen.vue?vue&type=script&lang=js&"
export * from "./Hengelen.vue?vue&type=script&lang=js&"
import style0 from "./Hengelen.vue?vue&type=style&index=0&id=32490667&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports